var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_component-radio-slot",
      class: { active: _vm.value, disabled: _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "component-radio-render" }),
      _c(
        "div",
        { staticClass: "component-contnet-wrap" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }